import { ref } from 'vue'

// One shared notice for concurrent HTTP requests and WebSocket authentication.
export const licenseRetryNotice = ref(false)
export function notifyLicenseRetryExhausted() {
  licenseRetryNotice.value = true
}
